import Immutable from 'immutable';

import type ErrorData from 'sharedreact/data/ErrorData';
import ConnectionSupport from 'sharedreact/utils/ConnectionSupport';

import Agent from 'workspaces/launcher/data/Agent';

type OnFetchSuccess = (items: Immutable.List<Agent>) => void;
type OnRemoveAgentsSuccess = (ids: Immutable.List<string>) => void;
type OnError = (error: ErrorData) => void;

function fetch (
  onSuccess: OnFetchSuccess,
  onError: OnError
) {
  ConnectionSupport.post(
    'getAgents',
    {},
    (data) => {
      onSuccess(
        Immutable.List(data.map((item: object) => Agent.fromJS(item))));
    },
    onError
  );
}

function removeAgents (userIds: Immutable.List<string>, onSuccess: OnRemoveAgentsSuccess, onError: OnError): void {
  ConnectionSupport.post(
    'removeAgents',
    {ids: userIds},
    (data) => onSuccess(Immutable.List(data.ids)),
    onError
  );
}

const AgentsConnection = {
  fetch,
  removeAgents
};

export default AgentsConnection;
